import type { FeatureFlags } from '@noths/polaris-client-feature-flags';
import { fetchSiteChromeContent } from '@noths/polaris-client-site-chrome-ui';

import { logger } from 'src/utils/serverLogger';
import { getContentstackEnvironment } from './utils';

interface GlobalContentOptions {
  featureFlags: FeatureFlags;
  isPreview?: boolean;
  urlPath?: string;
}

export const fetchGlobalContent = async ({
  featureFlags,
  isPreview = false,
}: GlobalContentOptions) => {
  const env = getContentstackEnvironment(isPreview);
  const config = { env, logger };
  const navContentVariantId = featureFlags.nav_content_experiment;

  return Promise.all([fetchSiteChromeContent(config, navContentVariantId).catch(() => null)]);
};
